'use strict';

import * as angular from 'angular';
var app = angular.module('noc.monitoring', []);

app.factory('DetailWindowFactory', require('./detail-window/detailWindowFactory'));
app.factory('ZabbixIssueFactory', require('./pages/alarm/zabbixIssueFactory'));
app.factory('ZabbixOverviewFactory', require('./pages/alarm/zabbixOverviewFactory'));
app.factory('InvestigateStateChangeFactory', require('./views/investigateStateChangeFactory'));
app.factory('TrainFilterFactory', require('./views/trainFilterFactory'));

app.service('MonitoringTrainDetailsService', require('./services/monitoringTrainDetailsService'));
app.service('MonitoringStoreService', require('./store/monitoringStoreService'));

app.controller('AlarmMonitoringPageController', require('./pages/alarm/alarmMonitoringPageController'));
app.controller('DetailWindowMonitoringController', require('./detail-window/detailWindowMonitoringController'));
app.controller('SimMonitoringPageController', require('./pages/sim/simMonitoringPageController'));
app.controller('SummaryMonitoringPageController', require('./pages/summary/summaryMonitoringPageController'));
app.controller('SynchronizationMonitoringPageController', require('./pages/synchronization/synchronizationMonitoringPageController'));
app.controller('EventMonitoringPageController', require('./pages/event/eventMonitoringPageController.js'));
app.controller('AlarmsMonitoringViewController', require('./views/alarmsMonitoringViewController'));
app.controller('InformationMonitoringViewController', require('./views/informationMonitoringViewController'));
app.controller('MapMonitoringViewController', require('./views/mapMonitoringViewController'));
app.controller('TableMonitoringViewController', require('./views/tableMonitoringViewController'));
app.controller('TilesMonitoringViewController', require('./views/tilesMonitoringViewController'));


app.directive('trainCanvas', require('./directives/trainCanvasDirective'));
app.directive('alarmDetails', require('./directives/alarmDetails'));
app.directive('monitoringFilters', require('./directives/monitoringFilters'));
app.directive('onFinishRender', require('./directives/onFinishRender'));
app.directive('cellHighlight', require('./directives/cellHighlight'));
app.directive('context', require('./directives/context'));
app.directive('trainSummary', require('./directives/trainSummaryDirective'));
app.directive('trainsMap', require('./directives/trainsMapDirective'));

app.component('alarmList', require('./components/alarmList/alarmList'));
app.component('trainInfoTable', require('./components/trainInfoTable/trainInfoTable'));

app.filter('devicePropertyVisibility', require('./filters/devicePropertyVisibility'));

export default app;